var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center my-5"},[_c('v-col',{staticClass:"mb-5",attrs:{"cols":"12"}},[_c('TenantsCard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }